import React from 'react';
import styled from 'styled-components';

import FeelingLuckyIcon from '../svgs/FeelingLuckyIcon';

type Props = {
  icon?: React.ReactNode;
  text?: string | React.ReactNode;
  iconSize?: number;
  spinnerSize?: number;
  spinnerWidth?: number;
};

const SimpleLoadingSpinner = ({
  icon = <FeelingLuckyIcon strokeColor="#17c964" />,
  text = 'Loading...',
  iconSize,
  spinnerSize,
  spinnerWidth,
}: Props) => {
  return (
    <Content>
      <SpinnerWrapper size={spinnerSize}>
        <Icon size={iconSize}>{icon}</Icon>
        <Spinner spinnerWidth={spinnerWidth}></Spinner>
      </SpinnerWrapper>
      {text && <Text>{text}</Text>}
    </Content>
  );
};

export default SimpleLoadingSpinner;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

const Text = styled.p`
  color: #f3e9d7;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  margin: 0;
`;

const SpinnerWrapper = styled.div<{ size?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: ${props => props.size || 80}px;
  height: ${props => props.size || 80}px;
  position: relative;
`;

const Spinner = styled.div<{ spinnerWidth?: number }>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border: ${props => props.spinnerWidth || 5}px solid #484848;
  border-top: ${props => props.spinnerWidth || 5}px solid #17c964;
  border-left: ${props => props.spinnerWidth || 5}px solid #17c964;
  border-right: ${props => props.spinnerWidth || 5}px solid #17c964;
  border-radius: 50%;
  animation: spin 2s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Icon = styled.div<{ size?: number }>`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.size || 25}px;
  height: ${props => props.size || 24}px;
`;
